const Form043EN = {
    stepName: {
        statement: "Important Notes",
        essentialInfo: "Basic Information",
        segmentInfo: "Segment Information",
        confirmation: "Confirmation",
    },
    deadlineTip: "This form is overdue and cannot be submitted",
    label: {
        title: {
            tips: "Basic Information",
            tipsTwo: "Total Approved Capacity",
        },
        tips: {
            am: "AM",
            pm: "PM",
            fullday: "WD",
        },
        kindergartenName: "Name of Kindergarten",
        childCareCenterName: "Name of Child Care Centre",
        classroomNumber: "Total No. of Registered Classroom (if applicable)",
        classroomPlacesNumber:
            "Total Permitted Accommodation (if applicable, please refer to Certificate of Accommodation)",
        halfDaySystem: "Half Day",
        fullTime: "Whole Day",
        morningFieldA: "0–2 (Age)",
        morningFieldB: "2–3 (Age)",
        morningFieldC: "3–6 (Age)",
        morningFieldD: "2–6 (Age)",
        afternoonFieldA: "0–2 (Age)",
        afternoonFieldB: "2–3 (Age)",
        afternoonFieldC: "3–6 (Age)",
        afternoonFieldD: "2–6 (Age)",
        fullTimeFieldA: "0–2 (Age)",
        fullTimeFieldB: "2–3 (Age)",
        fullTimeFieldC: "3–6 (Age)",
        fullTimeFieldD: "2–6 (Age)",
        code: {
            kindergartenName: "Kindergarten",
            childCareCenterName: "Child Care Centre",
        },
    },
    label2: {
        title: {
            tips: "Segment Information",
            tipsD: "No. of Pupils / Children Enrolled",
            tipsThree: "Contact Information",
        },
        tips: {
            tipsA: "AM",
            tipsB: "PM",
            tipsC: "WD",
        },
        tips2: {
            tipsC: "K1",
            tipsD: "K2 ",
            tipsE: "K3",
            tipsA: "Group aged below 2",
            tipsB: "Group aged 2-3",
        },
        note: {
            note1: "For enquiry, please contact",
            note2: "at",
            note3: "",
        },
        signType: {
            supervisor: "School Supervisor",
            schoolHead: "School Principal",
        },
        segmentInformation: "Session (AM / PM / WD)",
        kGClassOrGroup: "KG Class / CCC Group",
        classroomName: "Name of Classroom (if applicable) (e.g.1,2 / A,B)",
        classroomApproval:
            "Permitted Accommodation (if applicable) (Please refer to Certificate of Accommodation)",
        childrenEnrolled: "No. of Pupils / Children Enrolled",
        remarks: "Remarks",
        aMSubtotal: "AM Subtotal",
        pMSubtotal: "PM Subtotal",
        wDSubtotal: "WD Subtotal",
        total: "Total",
        conditionsCheck:
            "I confirm the information given in this return is true, correct and complete.",
        contacts: "Contact person",
        signInfo: "Signing Information",
        signPerson: "School Supervisor / Principal",
        signPersonName: "Name of Supervisor / Principal",
    },
    label1: {
        header: {
            headerOne: "Notes for completing the Form",
        },
        // content: "Please return on or before {{date}}.",
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        statement1:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        importantNote1: "Please return on or before {{deadline}} each year",
        // importantNote2: "(As at {{asAtDate}})",
    },
    errorMsg: {
        required: "This field is required",
        total: "Total approved capacity must be greater than 0",
        note: "Name of Kindergarten / Name of Child Care Centre must be filled in one of them",
        note2: "No more than 200 characters / Chinese no more than 30 characters",
        note3: "Please enter the correct content",
        note4: "No. of Pupils / Children Enrolled is greater than Permitted Accommodation, please specify",
        note5: "Please enter N/A if not applicable",
    },
};
export default Form043EN;
